import cloudDisplayAnimation from "./animation/cloudDisplayAnimation";
import appleDisplayAnimation from "./animation/appleDisplayAnimation";
import sunDisplayAnimation from "./animation/sunDisplayAnimation";
import rainbowDisplayAnimation from "./animation/rainbowDisplayAnimation";
import catchDisplayAnimatin from "./animation/catchDisplayAnimatin";
import textDisplayAnimation from "./animation/textDisplayAnimation";
import logoDisplayAnimatin from "./animation/logoDisplayAnimatin";
import logoRollAnimatin from "./animation/logoRollAnimatin";
import backgroundDisplayAnimation from "./animation/backgroundDisplayAnimation";
import sterDisplayAnimation from "./animation/sterDisplayAnimation";

export default function() {
  window.addEventListener("DOMContentLoaded", () => {
    if (document.getElementById("top")) {
      cloudDisplayAnimation();
      appleDisplayAnimation();
      sunDisplayAnimation();
      rainbowDisplayAnimation();
      catchDisplayAnimatin();
      textDisplayAnimation();
      logoDisplayAnimatin();
      logoRollAnimatin();
      sterDisplayAnimation();
      backgroundDisplayAnimation();
    }
  });
}
